import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=44c00504&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=44c00504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c00504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/lgweek/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c00504')) {
      api.createRecord('44c00504', component.options)
    } else {
      api.reload('44c00504', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=44c00504&scoped=true", function () {
      api.rerender('44c00504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/Video.vue"
export default component.exports